// extracted by mini-css-extract-plugin
export default {"modalContainer":"ImagePreview_modalContainer__sQEJU","thumbImg":"ImagePreview_thumbImg__XSvCP","img":"ImagePreview_img__nqdzU"};